// @flow

import React, { Component } from 'react';

// header

type Props = {
    teams: { [key: string]: any },
    handleFilterChange: Function,
    handleTeamFilterClick: Function
};

class Teams extends Component<Props> {
    handleTeamClick = (teamId: number) => {
        const teams = [];
        this.props.teams.results.map(team => {
            if (team.team_id === teamId) {
                if (team.selected === undefined) {
                    team.selected = false;
                } else {
                    team.selected = !team.selected;
                }
            }
            teams.push(team);
            return null;
        });

        this.props.teams.results = teams;
        this.handleFilterChange(teams);
    };

    handleAllClick = () => {
        const teams = [];
        this.props.teams.results.map(team => {
            team.selected = true;
            teams.push(team);
            return null;
        });
        this.props.teams.results = teams;
        this.handleFilterChange(teams);
    };

    handleNoneClick = () => {
        const teams = [];
        this.props.teams.results.map(team => {
            team.selected = false;
            teams.push(team);
            return null;
        });
        this.props.teams.results = teams;
        this.handleFilterChange(teams);
    };

    handleFilterChange = (e: ?Array<any>) => {
        const teams = [0];
        if (!!e && e.length > 0) {
            e.map(team => {
                if (team.selected === undefined || team.selected === true) {
                    teams.push(team.team_id);
                }
                return null;
            });
        }
        this.props.handleFilterChange(teams, 'Team');
    };

    render() {
        let teamData;

        if (this.props.teams.results.length > 0) {
            teamData = (
                <div className="event-filter" style={{ display: 'flex' }}>
                    <div className="event-team-header">
                        <button className="btn-chevron" onClick={() => this.props.handleTeamFilterClick()}>
                            <i className="fa fa-chevron-right" style={{ marginTop: '5px' }} />
                        </button>

                        <h3>Team Filter</h3>
                    </div>
                    <div className="event-team-body">
                        <button className="btn btn-link" onClick={() => this.handleAllClick()}>
                            Select All
                        </button>
                        |
                        <button className="btn btn-link" onClick={() => this.handleNoneClick()}>
                            Select None
                        </button>
                        <ul>
                            {this.props.teams.results.map(team => {
                                const teamDisplay = (
                                    <li className="team-list" key={team.team_id}>
                                        <div
                                            className="event-team-team"
                                            onClick={() => this.handleTeamClick(team.team_id)}
                                        >
                                            <img
                                                title="Click to show/hide players from this team"
                                                src={
                                                    'https://media.fantasylabs.com/assets/teams/' +
                                                    team.team_id +
                                                    '.gif'
                                                }
                                                className={team.selected !== false ? 'active' : ''}
                                                alt={''}
                                            />
                                        </div>
                                    </li>
                                );
                                return teamDisplay;
                            })}
                        </ul>
                    </div>
                </div>
            );
        } else {
            teamData = 'No teams played during the selected dates.';
        }

        const display = <div style={{ display: 'flex' }}>{teamData}</div>;

        return display;
    }
}

export default Teams;



// WEBPACK FOOTER //
// ./src/components/Main/Teams/Teams.js